import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Stepper, Step } from "../../../UI/Stepper";
import classes from "./EditAssessmentWithContent.module.css";
import AssessmentDetails from "./AssessmentDetails";
import Final from "./Final";
import { assessmentsApi } from '../../../../utils'
import { SourceTypeTextEnum } from '../../../../models/SourceTypeEnum'
import { useLocation, useNavigate } from "react-router-dom";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { ActivityTypeEnum, ActivityTypeEnumText } from "../../../../models/ActivityTypeEnum";


const EditAssessmentWithoutContent = ({ isNew, courseName, tocName, isProfession, studyGroupId, activityType }) => {

    const texts = useSelector(state => state.translate.texts);
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const homeUrl = useSelector((state) => state.application.homeUrl);

    const [assessment, setAssessment] = useState({
        id: null,
        contentData: null,
        name: "",
        description: null,
    })

    const getActivityTypeText = (type) => {
        const entry = Object.entries(ActivityTypeEnum).find(([key, value]) => value === type);
        return entry ? ActivityTypeEnumText[entry[0]] : null;
    }

    const createOrUpdate = (newAssessment) => {
        if (!newAssessment.id) {
            //create
            console.log("CREATE")
            // location.state?.lessonId
            let data = {
                lessonId: location.state?.lessonId,
                sourceType: SourceTypeTextEnum.IDE,
                activityType: getActivityTypeText(activityType),
                name: newAssessment.name,
                description: newAssessment.description
            }
            assessmentsApi.assessmentsAddPost({ assessmentAddInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.assessmentsAddError, error: error, statusCode: response?.statusCode, message: "assessmentsAddPost " + error.message, level: 2, component: "EditAssessmentWithoutContent", line: 41 }))
                }
                else {
                    console.log('resdata', resdata);
                    newAssessment.id = resdata.id
                    newAssessment.contentData = resdata.contentData
                    setAssessment(newAssessment)
                }
            })
        } else {
            //update
            console.log("UPDATE")
            let data = {
                id: newAssessment.id,
                contentData: newAssessment.contentData,
                name: newAssessment.name,
                description: newAssessment.description
            }
            assessmentsApi.assessmentsUpdatePost({ assessmentUpdateInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.assessmentsUpdateError, error: error, statusCode: response?.statusCode, message: "assessmentsUpdatePost " + error.message, level: 2, component: "EditAssessmentWithoutContent", line: 62 }))
                }
                else {
                    console.log('resdata', resdata);
                    setAssessment(newAssessment)
                }
            })
        }
    }

    // AssessmentDetails
    const handleChangeBaseProperties = (name, description) => {
        let newAssessment = { ...assessment, description: description, name: name }
        createOrUpdate(newAssessment)
    }

    const onEnd = () => {
        if (studyGroupId)
            navigate(`${homeUrl}/${isProfession ? "admin/disciplines" : "courses"}/${studyGroupId}`)
        else
            navigate(`${homeUrl}/${isProfession ? "admin/disciplines" : "courses"}`)
    }

    return (
        <div className={classes.NewAssessment}>
            <Stepper onEnd={onEnd} title={!isNew ? texts.editAssessment : texts.openNewAssessment} courseName={courseName} tocName={tocName} subTitle={assessment.name ? assessment.name : texts.newAssessment} canEditAll={!isNew} arrowOnClick={() => { navigate(-1) }}>
                <Step description={`${texts.details} ${texts.assessment}`} buttonText={texts.saveAndContinue}><AssessmentDetails assessment={assessment} handleChangeBaseProperties={handleChangeBaseProperties} /></Step>
                <Step><Final /></Step>
            </Stepper>
        </div >
    )
}

export default EditAssessmentWithoutContent;